export const FETCH_CUSTOMER_PENDING = "FETCH_CUSTOMER_PENDING";
export const FETCH_CUSTOMER_REJECTED = "FETCH_CUSTOMER_REJECTED";
export const FETCH_CUSTOMER_FULFILLED = "FETCH_CUSTOMER_FULFILLED";
export const REMOVE_CUSTOMER_DETAIL = "REMOVE_CUSTOMER_DETAIL";


// WEBPACK FOOTER //
// ./src/constants/customerDetail.js